export default "__VITE_ASSET__CTk4VVvG__"